import {css} from 'lit';
export const styles = css`.breadcrumb{display:flex;flex-direction:column;gap:.25rem}.breadcrumb .breadcrumb-items{display:flex;gap:.5rem}`;
export default styles;
